<svg width="19" height="8" viewBox="0 0 19 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.4 4.8L16.8 4.8L14.4 7.2L15.2 8L19 4.2L15.2 0.5L14.4 1.3L16.6 3.6L0.4 3.6L0.4 4.8Z" fill="currentColor"/>
</svg>
